const domain = window.parent.location.origin;

export const CATEGORIES = "/categories";
export const MANAGE_USERS = "/";
export const PLATFORM_SETTINGS_URL = domain + "/platformwebapp/settings";
export const PLATFORM_DATAMANAGEMENT_URL = domain + "/platformwebapp/datamanagement#linkclients";
export const PLATFORM_DATAENTITIES_URL = domain + "/platformwebapp/settings#dataentities";
export const PLATFORM_FLAG_UPDATE_URL = domain + "/platformwebapp/Licensing/StartStaffIntegrationPhase2";
export const PLATFORM_TOKEN_STATUS_URL = domain + "/platformwebapp/api/Application";
export const WS_WF_MIGRATION_URL = domain + "/migrationui";
export const CPAUTILITIES = domain + "/xcmv2/CPAUtilities";